<template>
  <div class="chart-container">
    <h3 v-if="title" class="chart-title">{{ title }}</h3>

    <v-card class="chart-card">
      <div
        class="chart-card__header"
        :class="{ 'chart-card__header--extended': !!$slots['filters'] }"
      >
        <div v-if="!!$slots['filters']" class="chart-sentiment-filters">
          <slot name="filters" />
        </div>
        <div class="chart-period-filters">
          <v-btn
            rounded
            depressed
            :color="isWeekFilterActive"
            @click="getChartData(REVIEWS_DATA_PERIOD.WEEK)"
            >{{ $t("message.reviews.periods.weekly") }}</v-btn
          >
          <v-btn
            rounded
            depressed
            :color="isMonthFilterActive"
            :disabled="isMonthDisabled"
            @click="getChartData(REVIEWS_DATA_PERIOD.MONTH)"
            >{{ $t("message.reviews.periods.monthly") }}</v-btn
          >
        </div>
      </div>
      <slot v-if="!isLoading" name="chart" />
      <div v-else class="chart-loader">
        <v-progress-circular indeterminate color="primary" />
      </div>
    </v-card>
  </div>
</template>

<script>
import { REVIEWS_DATA_PERIOD } from "@/enums/reviews-data-period.enum";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";
import constants from "@/config/constants";
import { FORMAT } from "@/config/date-format";
import moment from "moment";
export default {
  name: "ReviewsCategoriesChartWrapper",
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    title: {
      type: String
    }
  },
  data() {
    return {
      REVIEWS_DATA_PERIOD,
      chartFilter: REVIEWS_DATA_PERIOD.WEEK
    };
  },
  computed: {
    isMonthDisabled() {
      if (this.$route.query.dateType === "weeks") {
        return +this.$route.query.dateQuantity <= 4;
      }
      if (this.$route.query.dateType === "days") {
        return +this.$route.query.dateQuantity <= 30;
      }
      if (this.$route.query.dateType === "months") {
        return +this.$route.query.dateQuantity == 1;
      }

      return false;
    },
    isWeekFilterActive() {
      return this.chartFilter === REVIEWS_DATA_PERIOD.WEEK
        ? "primary"
        : "default";
    },
    isMonthFilterActive() {
      return this.chartFilter === REVIEWS_DATA_PERIOD.MONTH
        ? "primary"
        : "default";
    }
  },
  methods: {
    getChartData(view) {
      this.chartFilter = view;

      this.$gtm.trackCustomEvent({
        event:
          GTM_EVENT_NAME.REVIEW_CATEGORY_ANALYTICS_DETAILS_CHART_TIMEGROUP_CHANGE,
        timegroup: view === "week" ? "weekly" : "monthly",
        date_from:
          this.$route.query.dateType === constants.fullPeriod
            ? moment(constants.absoluteStartDate).format(FORMAT.DATE)
            : this.$route.query.selectedFrom,
        date_to:
          this.$route.query.dateType === constants.fullPeriod
            ? moment(Date.now()).format(FORMAT.DATE)
            : this.$route.query.selectedTo
      });
      this.$emit("get-chart-data", view);
    }
  },
  watch: {
    isMonthDisabled: {
      immediate: true,
      async handler(current) {
        if (current) {
          this.chartFilter = REVIEWS_DATA_PERIOD.WEEK;
          this.$emit("get-chart-data", this.chartFilter);
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep canvas {
  height: 530px !important;
}

.chart-sentiment-filters {
  display: flex;
  gap: $spacing * 4;
  align-items: center;
  padding: 0 $spacing;
}
.chart-period-filters {
  display: flex;
  gap: $spacing * 2;
}

.chart-loader {
  height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.chart-filters {
  display: flex;
  gap: $spacing * 2;
}
.chart-title {
  @include font-size(22px);
  margin-bottom: $spacing * 3;
}
.chart-card {
  filter: none !important;
  &__header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: $spacing * 3;
    align-items: center;

    &--extended {
      justify-content: space-between;
    }

    > * + * {
      margin-left: $spacing;
    }
    ::v-deep .v-btn {
      text-transform: none;
      letter-spacing: 0;
    }
  }
}
</style>
